import { OrderVersionDto } from "../../../interfaces/OrderDetail";
import { OrderDetailsDraft } from "./hooks/useOrderDetailsEdit";

export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export const hasValue = (
  value: string | number | null | undefined,
): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
};

export const hasShipToChanges = (
  draft: OrderDetailsDraft,
  version: OrderVersionDto,
) => {
  return (
    (draft.shippingName ?? "").trim() !== (version.shippingName ?? "").trim() ||
    (draft.shippingAddress ?? "").trim() !==
      (version.shippingAddress ?? "").trim() ||
    (draft.shippingCity ?? "").trim() !== (version.shippingCity ?? "").trim() ||
    (draft.shippingState ?? "").trim() !==
      (version.shippingState ?? "").trim() ||
    (draft.shippingZip ?? "").trim() !== (version.shippingZip ?? "").trim()
  );
};

export const hasPoolOwnerChanges = (
  draft: OrderDetailsDraft,
  version: OrderVersionDto,
) => {
  return (
    (draft.poolOwnerFirstName ?? "").trim() !==
      (version.poolOwnerFirstName ?? "").trim() ||
    (draft.poolOwnerLastName ?? "").trim() !==
      (version.poolOwnerLastName ?? "").trim() ||
    (draft.poolOwnerAddress ?? "").trim() !==
      (version.poolOwnerAddress ?? "").trim() ||
    (draft.poolOwnerCity ?? "").trim() !==
      (version.poolOwnerCity ?? "").trim() ||
    (draft.poolOwnerState ?? "").trim() !==
      (version.poolOwnerState ?? "").trim() ||
    (draft.poolOwnerZip ?? "").trim() !== (version.poolOwnerZip ?? "").trim()
  );
};

export const hasFobChanges = (
  draft: OrderDetailsDraft,
  version: OrderVersionDto,
) => {
  return draft.fob.trim() !== (version.fob ?? "").trim();
};

export const hasShipViaChanges = (
  draft: OrderDetailsDraft,
  version: OrderVersionDto,
) => {
  return draft.shipVia !== (version.shipVia ?? "")
};
